import script from "./leaveWords.vue?vue&type=script&setup=true&lang=js"
export * from "./leaveWords.vue?vue&type=script&setup=true&lang=js"

import "./leaveWords.vue?vue&type=style&index=0&id=5053ef1c&lang=css"

const __exports__ = script;

export default __exports__